import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Image } from "antd";
import {
  rehydrateWithSessionStorage,
  showAppleInstallationInfo,
  showAppleInstallationDrawer,
  fetchOspedali,
  getOspedali,
  fetchOspedaliEnded,
  getPrivacyAcceptedFlag,
} from "../../modules/common";
import { isMobileMode } from "../../modules/configuration";
import surgeryTrackerBianco from "../../styles/images/loghi/surgeryTracker_bianco.png";
import { AppleInstallationDrawer } from "../shared/AppleInstallationDrawer";
import { PATH_CERCA } from "../../path";
import { NESSUN_OSPEDALE_TITLE, NESSUN_OSPEDALE_MESSAGE } from "../../modules/language";
import { notificationCodes, resetNotification, setNotification } from "../../modules/notification";
import { salvaInfoStruttura } from "../../modules/surgery";

const checkAppleDevice = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let check = false;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) check = true;
  return check;
};

const HomePageBase = ({ history, idStruttura }) => {
  const dispatch = useDispatch();
  const ospedali = useSelector(getOspedali);
  const mobileMode = useSelector(isMobileMode);
  const showDrawer = useSelector(showAppleInstallationDrawer);
  const isFetchEnded = useSelector(fetchOspedaliEnded);
  const privacyCookie = useSelector(getPrivacyAcceptedFlag);
  const iOsDevice = checkAppleDevice();

  const staticInfo = localStorage.getItem("staticInfo");

  useEffect(() => {
    if (!ospedali) {
      if (staticInfo) {
        dispatch(rehydrateWithSessionStorage(JSON.parse(staticInfo)));
        localStorage.removeItem("staticInfo");
      } else dispatch(fetchOspedali());
    }
    // eslint-disable-next-line
  }, [staticInfo, ospedali]);

  useEffect(() => {
      if (iOsDevice && showDrawer === null) dispatch(showAppleInstallationInfo(true));
    // eslint-disable-next-line
  }, [iOsDevice, showDrawer]); //prettier-ignore

  const onDrawerClose = () => dispatch(showAppleInstallationInfo(false));

  useEffect(() => {
    if (isFetchEnded) {
      if (ospedali && ospedali !== undefined && ospedali.length > 0) {
        dispatch(resetNotification());
        const idEnte = ospedali.find((ospedale) => ospedale.strutture.map((struttura) => struttura.id).includes(idStruttura)); //prettier-ignore
        if (idEnte && idEnte !== undefined && !idEnte.disabled) dispatch(salvaInfoStruttura(idEnte.id, idStruttura));
        setTimeout(() => {
          history.push(PATH_CERCA);
        }, 2500);
      } else dispatch(setNotification(notificationCodes.ERROR, NESSUN_OSPEDALE_TITLE, NESSUN_OSPEDALE_MESSAGE));
    }
    // eslint-disable-next-line
  }, [ospedali, privacyCookie, isFetchEnded]);

  window.addEventListener("appinstalled", () => dispatch(showAppleInstallationInfo(false)));

  return (
    <div className={mobileMode ? "mobileHomePage" : "desktopHomePage"}>
      <h1>Surgery Tracker</h1>
      <Image id="logoSurgery" alt="Logo Surgery Tracker" src={surgeryTrackerBianco} preview={false} />
      {showDrawer && <AppleInstallationDrawer isVisible={showDrawer} onClose={onDrawerClose} />}
    </div>
  );
};

export const Home = withRouter(HomePageBase);
